@switch (context ? context.type : '') {
    @default {
        <fui-edit-checkbox-input [disabled]="disabled" [readonly]="readOnlyNotDisabled"
                                 #input [label]="label" [labelI18NParams]="labelI18NParams" [(ngModel)]="value"
                                 (focussed$)="onFocussed($event)"></fui-edit-checkbox-input>
    }
    <!--    <fui-filter-checkbox-input [disabled]="disabled" #input [label]="label" [labelI18NParams]="labelI18NParams" [(ngModel)]="value"
  (focussed$)="onFocussed($event)" *ngSwitchCase="contextType.FILTER"></fui-filter-checkbox-input> -->
    @case (contextType.INLINE) {
        <fui-inline-checkbox-input [disabled]="disabled" [readonly]="readOnlyNotDisabled"
                                   #input [label]="label" [labelI18NParams]="labelI18NParams" [(ngModel)]="value"
                                   (focussed$)="onFocussed($event)"></fui-inline-checkbox-input>
    }
    @case (contextType.INLINE_ACTION) {
        <fui-inline-checkbox-input [disabled]="disabled" [readonly]="readOnlyNotDisabled"
                                   #input [label]="label" [labelI18NParams]="labelI18NParams" [(ngModel)]="value"
                                   class="action"
                                   (focussed$)="onFocussed($event)"></fui-inline-checkbox-input>
    }
    @case (contextType.PILL) {
        <fui-checkbox-pill (focussed$)="onFocussed($event)"></fui-checkbox-pill>
    }
    @case (contextType.POP) {
        <fui-pop-checkbox-input [disabled]="disabled" [readonly]="readOnlyNotDisabled"
                                #input [label]="label" [labelI18NParams]="labelI18NParams" [(ngModel)]="value"
                                (focussed$)="onFocussed($event)"
                                [allowLabelMarkup]="allowLabelMarkup"></fui-pop-checkbox-input>
    }
}
